var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.authUser)?_c('v-sheet',{staticClass:"fill-height"},[(_vm.dashboardPermission)?[_c('public-statistics',{ref:"publicReport",attrs:{"print":_vm.print}})]:_vm._e()],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }